// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CustomerServiceFilledSvg from "@ant-design/icons-svg/es/asn/CustomerServiceFilled";
import AntdIcon from '../components/AntdIcon';

var CustomerServiceFilled = function CustomerServiceFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CustomerServiceFilledSvg
  }));
};

CustomerServiceFilled.displayName = 'CustomerServiceFilled';
export default React.forwardRef(CustomerServiceFilled);